import React from 'react';
import './FeaturesPage.css';

const FeaturesPage = () => {
  return (
    <div id="features" className="features-section">
      <div className="container">
        <h2>Features</h2>
        <p>Discover the amazing features of UniVerse.</p>
        <div className="features-list">
          {/* Feature 1: Academic Guidance */}
          <div className="feature-card">
            <div className="feature-icon">📚</div>
            <div className="feature-text">
              <h3>Academic Guidance</h3>
              <h4>Personalized Course Recommendations</h4>
              <p>
                UniVerse analyzes your major requirements, interests, and scheduling constraints to suggest classes that fit your goals—no more guesswork or endless browsing.
              </p>
              <h4>AI-Powered Advising</h4>
              <p>
                Ask Athena, our intelligent assistant, for instant help: from finding the best electives to planning your four-year course load.
              </p>
              <h4>Automated Alerts & Deadlines</h4>
              <p>
                Stay on top of registration windows, drop/add deadlines, and upcoming assignments with real-time notifications.
              </p>
              <p className="benefit"><strong>Benefit:</strong> Reduces the time and stress of navigating traditional advising channels, giving you more control over your academic path.</p>
            </div>
          </div>

          {/* Feature 2: Campus Info */}
          <div className="feature-card">
            <div className="feature-icon">🏫</div>
            <div className="feature-text">
              <h3>Campus Info</h3>
              <h4>Real-Time Facility Updates</h4>
              <p>
                Check dining hall menus, library hours, and gym availability in one unified dashboard.
              </p>
              <h4>Event & Workshop Calendar</h4>
              <p>
                Get instant updates on guest lectures, career fairs, and club meetings so you never miss important happenings.
              </p>
              <h4>Campus Alerts & Announcements</h4>
              <p>
                Receive notifications for urgent updates—building closures, emergency alerts, or last-minute schedule changes.
              </p>
              <p className="benefit"><strong>Benefit:</strong> Keeps you informed about everything happening on campus, all in one place, eliminating the need to search through multiple university portals.</p>
            </div>
          </div>

          {/* Feature 3: Community Building */}
          <div className="feature-card">
            <div className="feature-icon">🤝</div>
            <div className="feature-text">
              <h3>Community Building</h3>
              <h4>University-Exclusive Networks</h4>
              <p>
                Connect with classmates, professors, and alumni through verified forums and groups, open only to your institution.
              </p>
              <h4>Peer Collaboration</h4>
              <p>
                Form study groups, discuss course material, or organize club projects—all without leaving UniVerse.
              </p>
              <h4>Alumni & Mentor Engagement</h4>
              <p>
                Reach out to alumni for mentorship, internship referrals, or industry advice, fostering a lifelong professional network.
              </p>
              <p className="benefit"><strong>Benefit:</strong> Fosters a deeper sense of belonging and collaboration, turning your campus into a thriving community both online and offline.</p>
            </div>
          </div>

          {/* Feature 4: Centralized Workspace */}
          <div className="feature-card">
            <div className="feature-icon">🗂</div>
            <div className="feature-text">
              <h3>Centralized Workspace</h3>
              <h4>Unified Dashboard</h4>
              <p>
                All your courses, deadlines, and to-dos appear in a single, customizable interface.
              </p>
              <h4>Document & Resource Management</h4>
              <p>
                Upload lecture notes, store research papers, and track assignment files without juggling multiple file-sharing platforms.
              </p>
              <h4>Collaboration Tools</h4>
              <p>
                Work on group projects in real time, leave comments, and version-control documents—streamlining the entire academic workflow.
              </p>
              <p className="benefit"><strong>Benefit:</strong> Eliminates the hassle of logging into different systems for class materials, assignments, and group work, keeping you organized and focused.</p>
            </div>
          </div>
        </div>

        {/* Why UniVerse Section */}
        <div className="why-universe">
          <h2>Why UniVerse?</h2>
          <p><strong>One Platform, Endless Possibilities</strong></p>
          <p>
            By consolidating academic guidance, campus info, community interaction, and work management, UniVerse ensures you spend less time navigating disjointed platforms and more time on what truly matters: learning, collaborating, and growing.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeaturesPage;